import { colors } from 'ui/theme/colors';
import { getColor } from 'ui/icons/utils';
import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const SendSMS24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M12.7071 21.2929L15 19H9L11.2929 21.2929C11.6834 21.6834 12.3166 21.6834 12.7071 21.2929Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 4C3.34315 4 2 5.34315 2 7V16C2 17.6569 3.34315 19 5 19H19C20.6569 19 22 17.6569 22 16V7C22 5.34315 20.6569 4 19 4H5ZM7 13C7.82843 13 8.5 12.3284 8.5 11.5C8.5 10.6716 7.82843 10 7 10C6.17157 10 5.5 10.6716 5.5 11.5C5.5 12.3284 6.17157 13 7 13ZM12 13C12.8284 13 13.5 12.3284 13.5 11.5C13.5 10.6716 12.8284 10 12 10C11.1716 10 10.5 10.6716 10.5 11.5C10.5 12.3284 11.1716 13 12 13ZM18.5 11.5C18.5 12.3284 17.8284 13 17 13C16.1716 13 15.5 12.3284 15.5 11.5C15.5 10.6716 16.1716 10 17 10C17.8284 10 18.5 10.6716 18.5 11.5Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
